var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.144,
    height: 17.144,
    viewBox: "0 0 17.144 17.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-11.428-17.5A8.572,8.572,0,0,0-20-8.928,8.572,8.572,0,0,0-11.428-.356,8.572,8.572,0,0,0-2.856-8.928,8.572,8.572,0,0,0-11.428-17.5Zm0,15.537a6.973,6.973,0,0,1-6.965-6.965,6.973,6.973,0,0,1,6.965-6.965A6.973,6.973,0,0,1-4.463-8.928,6.973,6.973,0,0,1-11.428-1.963Zm3.419-5.92-2.615-1.51v-4.089a.8.8,0,0,0-.8-.8.8.8,0,0,0-.8.8v4.554a.8.8,0,0,0,.4.7l3.016,1.741a1.09,1.09,0,0,0,.4.108.8.8,0,0,0,.7-.4A.8.8,0,0,0-8.009-7.883Z",
    transform: "translate(20 17.5)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.d7bc3a39d461f749dd59f698ba1fb581.svg";
export { ForwardRef as ReactComponent };